import FilterableProjects from "../Components/FilterableProjects";

export default function Resume() {
  return (
    <div className="bg-white text-black font-sans leading-relaxed px-6 md:px-20 py-10">
      <section className=" banner_section_padding">
        <div className="wrapper">
            <FilterableProjects />
        </div>
      </section>

      <section className="cta_section section_padding bg_dark all_text_white align_center">
            <div className="md_wrapper">
                <h2>Like what you see?</h2>
                <p>Explore more of my work or download my resume to get in touch.</p>
                <div className="buttons_container">
                <a href="/projects" className="cta_button White">
                    Explore more
                </a>
                <a href="https://drive.google.com/file/d/1H9crBoHWFWySRgASzmO_xQ9U6JuFnbQd/view?usp=drivesdk" className="cta_button white border">
                    Download resume
                </a>
                </div>
            </div>
      </section>
    </div>
  );
}
